export default __webpack_public_path__ + "static/media/b10.d62f1a03.png";